import {userConstants} from '../../_constants';

export function deliverySchedulerTime(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_SCHEDULER_TIME_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_SCHEDULER_TIME_SUCCESS:
      return {
        loading: false,
        // typeDelivery: action.data,
        ...action.data,
      };
    case userConstants.GET_SCHEDULER_TIME_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
